import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import style from './style.css'
import button from 'Styles/button.css'

export default function HintButton (props) {
  const ebookLegacySplitStyle = props.legacyEbook ? style.legacyButtonStyle : ''
  if (props.browser.lessThan.medium || props.splitPane) {
    const splitPaneStyle = props.footerWidth ? style.splitContent : ''

    return (
      <button
        aria-label='Get a hint'
        data-test-id="showHintBtn"
        className={classnames('btn-cdl-secondary', style.hintButtonBase, ebookLegacySplitStyle, splitPaneStyle)}
        onClick={props.onClick}
        tabIndex="0"
      >
        Hint
      </button>
    )
  } else {
    return (
      <button
        aria-label='Get a hint'
        data-test-id="showHintBtn"
        className={classnames('btn-cdl-secondary', style.hintButtonBase, ebookLegacySplitStyle)}
        onClick={props.onClick}
        tabIndex="0"
      >
        <div>Get a hint</div>
        <div className={button.footerButtonSubtext}>(fewer points)</div>
      </button>
    )
  }
}
HintButton.propTypes = {
  browser: PropTypes.object.isRequired,
  onClick: PropTypes.func.isRequired,
  splitPane: PropTypes.bool.isRequired,
  legacyEbook: PropTypes.bool,
  footerWidth: PropTypes.bool
}
